import React from 'react'
import PropTypes from 'prop-types'
import HighCharts from 'highcharts-react-official'
import merge from 'lodash.merge'
import Highcharts from './SpiderChartInstance'
import { GlobalStyle, Root } from './SpiderChart.styles'
import { DEFAULT_RESPONSIBE_RULES, CHARTS_OPTIONS, ACCESSIBILITY_OPTIONS } from './SpiderChart.constants'

/**
 * The SpiderChart's component.
 */
const SpiderChart = ({ id, title, categories, series, customOptions = {}, responsiveRules }) => {
  const defaultOptions = {
    chart: CHARTS_OPTIONS,
    accessibility: ACCESSIBILITY_OPTIONS,
    title: {
      text: title,
      x: 0,
      align: 'start',
      style: {
        fontSize: '16px',
        fontWeight: 'bold'
      }
    },
    pane: {
      size: '70%'
    },
    xAxis: {
      categories,
      tickmarkPlacement: 'on',
      lineWidth: 0,
      labels: {
        useHTML: true,
        formatter: function () {
          const category = this.value
          const index = categories.indexOf(category)
          const value = series[0].data[index]
          return `
            <p style="text-align: center">
              <span style="font-weight: bold; font-size: 15px; margin-bottom: 5px;">
                ${value?.toFixed(2)}
              </span>
              <br/>
              <span>
                ${category}
              </span>
            <p/>
          `
        }
      }
    },
    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0
    },
    plotOptions: {
      series: {
        fillOpacity: 0.3
      }
    },
    tooltip: {
      shared: true,
      pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:.2f}</b><br/>'
    },
    legend: {
      enabled: false
    },
    series,
    responsive: {
      rules: responsiveRules || DEFAULT_RESPONSIBE_RULES
    }
  }

  const options = merge({}, defaultOptions, customOptions)

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Highcharts} options={options} />
      </Root>
    </>
  )
}

SpiderChart.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  series: PropTypes.arrayOf(PropTypes.object).isRequired,
  customOptions: PropTypes.object,
  responsiveRules: PropTypes.arrayOf(PropTypes.object)
}

SpiderChart.defaultProps = {
  title: '',
  customOptions: {}
}

export default SpiderChart
